/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigAssetLoaderService } from '../../../services/config-asset-loader.service';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { CommonFuntions } from '../../../common/common.function';
import { EMAIL_TEMPLATE } from '../../../services/constant';
import { EmailTemplateModel } from '../../../domains/EmailTemplateModel';

declare let $: any;
@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})
export class EmailTemplateComponent implements OnInit {
  searchValue: string;
  totalMailServerCount: number;
  errorString: string;
  
  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};

  selectedSearchOption: '';
  searchColumn = {column: '',value: ''};
  searchColumnName = '';
  searchColumnValue='';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    private loginService: LoginService,
    private router: Router
  ) { }


  getColumnList(): any[] {
    return [
      {
        title: 'Name',
        data: 'name',
        render: $.fn.dataTable.render.text()
      },
      {
        title: 'Apply To',
        data: 'apply_to',
        render: $.fn.dataTable.render.text()
      },
      {
        title: 'Actions',
        data: null,
        orderable: false,
        render: (_data, _type, _full) => {
          return '<button id="editEmailTemplate" class="btn btn--green btn--mini" >Edit</button>';
        }
      }
    ];
  }

  setDatatableOption(): void {
    const URL = `${ConfigAssetLoaderService.getApiURL()}/${EMAIL_TEMPLATE.LIST}`;
    this.dtOptions = {
      ajax: {
        url: URL,
        dataSrc: function (json) {
          const { recordsTotal, data } = json;
          const model = data.map(eachItem => new EmailTemplateModel(eachItem));
          this.totalMailServerCount = recordsTotal;
          return model;
        }.bind(this),
        type: 'GET',
        beforeSend: function (xhr) {
          if (!CommonFuntions.guardForAction(this.loginService, this.router)) {
            xhr.abort();
            return;
          }

          this.errorString = null;
          const token = localStorage.getItem('token');
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        }.bind(this),
        error: this.datatablesError.bind(this)
      },
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      lengthChange: false,
      stateSave: true,
      searching: true,
      pageLength: 10,
      order: [[0, 'ASC']],
      info: false,
      columns: this.getColumnList(),
      rowCallback: (row: Node, data: EmailTemplateModel, _index: number) => {
        // Unbind first in order to avoid duplicate handler
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
          this.router.navigate(['email-templates/', data.id]);
        });

        /** Handle edit button click
         * Navigate to the outgoing mail server edit
         */
        $('#editEmailTemplate', row).on('click', () => {
          this.router.navigate(['email-templates/edit/', data.id]);
        });
      }
    };
  }

  ngOnInit(): void {
    localStorage.removeItem('DataTables_doctor_/email-templates');
    this.setDatatableOption();
  }

  searchRecord(data: any) {
    this.searchColumn.column = data.column;
    this.searchColumn.value = data.value;
    this.searchColumnName = data.searchColumnName;
    this.searchColumnValue = data.value;
    this.search(this.searchColumn);
  }
  search(value: any): void {
    this.datatableElement.dtInstance.then(
      (dtInstance: DataTables.Api) => {
        dtInstance.search(JSON.stringify(value)).draw();
      }
    );
  }


  datatablesError(xhr, _error, _thrown): void {
    const errorStatus = xhr.status;
    if (errorStatus == 401) {
      this.router.navigate(['/login']);
    }
    else if (errorStatus == 404) {
      this.errorString = 'Invalid Url';
    }
    else {
      this.errorString = 'Problem occurred. Please contact your administrator';
    }
  }

}
